document.addEventListener('DOMContentLoaded', function() {
  var videos = document.querySelectorAll('.video-wrapper video');

  videos.forEach(function(video) {
    var autoplayEnabled = video.getAttribute('data-autoplay') === 'true';

    var playPauseBtn = document.createElement('button');
    playPauseBtn.className = 'custom-play-pause';

    // Set the initial button appearance based on autoplay setting
    if (autoplayEnabled) {
      playPauseBtn.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <rect x="6" y="4" width="4" height="16"></rect>
          <rect x="14" y="4" width="4" height="16"></rect>
        </svg>
      `;
      playPauseBtn.style.display = 'none'; // Initially hide button if autoplay is enabled
      video.play(); // Autoplay the video if enabled
    } else {
      playPauseBtn.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <polygon points="5,3 19,12 5,21" />
        </svg>
      `;
      playPauseBtn.style.display = 'flex'; // Show button initially if autoplay is disabled
    }

    // Append the play/pause button to the video's parent node
    video.parentNode.appendChild(playPauseBtn);

    // Function to update the button appearance and behavior
    function updateButtonAppearance() {
      if (video.paused) {
        playPauseBtn.innerHTML = `
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <polygon points="5,3 19,12 5,21" />
          </svg>
        `;
        playPauseBtn.style.display = 'flex'; // Always show button when video is paused
      } else {
        playPauseBtn.innerHTML = `
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <rect x="6" y="4" width="4" height="16"></rect>
            <rect x="14" y="4" width="4" height="16"></rect>
          </svg>
        `;
        playPauseBtn.style.display = 'none'; // Hide button when video is playing if not hovering
      }
    }

    // Event listener for play/pause button click
    playPauseBtn.addEventListener('click', function() {
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
      updateButtonAppearance();
    });

    // Event listener for video play and pause events
    video.addEventListener('play', function() {
      if (autoplayEnabled) {
        playPauseBtn.style.display = 'none'; // Hide button when video is playing if autoplay is enabled
      }
      updateButtonAppearance();
    });

    video.addEventListener('pause', function() {
      updateButtonAppearance();
    });

    // Event listeners for mouse enter and leave on video container
    video.parentNode.addEventListener('mouseenter', function() {
      if (video.paused || autoplayEnabled || !autoplayEnabled) {
        playPauseBtn.style.display = 'flex'; // Show button on hover
      }
    });

    video.parentNode.addEventListener('mouseleave', function() {
      if (autoplayEnabled && !video.paused) {
        playPauseBtn.style.display = 'none'; // Hide button when mouse leaves and video is playing if autoplay is enabled
      } else if (!autoplayEnabled && !video.paused) {
        playPauseBtn.style.display = 'none'; // Hide button when mouse leaves and video is playing if autoplay is disabled
      }
    });

    // Initially update the button appearance
    updateButtonAppearance();
  });
});
